import {ConversionDocuments} from './ConversionDocuments';

export class ConversionResidents {
  residentID: string;
  firstName: string;
  lastName: string;
  gender: string;
  resident: string;
  ssn: string;
  dob: string;
  mrn: string;
  unit: string;
  documentsCount: number;
  residentErrorMessage: string;
  erroredDocumentList: ConversionDocuments[] = [];
}
